module.exports = [
  {
    name: 'CPC',
    html: {
      ru: '<strong>Cost Per Click</strong> — стоимость привлечения посетителя - затраты на привлечение одного посетителя с рекламной кампании на сайт или сервис.',
      en: 'Cost per acquisition of one User. It is determined by dividing the entire marketing budget by the number of all Users. Unlike CAC, CPA is an actionable metric. It doesn’t depend on other metrics, such as conversion or User flow.'
    }
  },
  {
    name: 'UA',
    html: {
      ru: 'User Acquisition - показатель, обозначающий число привлеченных с данного рекламного канала пользователей.',
      en: 'User Acquisition is an indicator that indicates the number of users attracted from this ad channel.'
    }
  },
  {
    name: 'CR1',
    html: {
      ru: 'Конверсия на первом шаге воронки (обычно в заявку) - процент посетителей сайта (сервиса) совершивших целевое действие для выхода на контакт (зарегистрировались, отправили заявку, позвонили).',
      en: 'Conversion on the first step of the funnel (usually in the application) - the percentage of visitors to the site (service) who committed the targeted action to contact (registered, sent an application, called).'
    }
  },
  {
    name: 'CR2',
    html: {
      ru: 'Конверсия на втором шаге воронки (обычно из заявки в продажу) - процент оставивших заявку пользователей, которые в конечном счете совершили транзакцию (совершили покупку, оплатили подписку и т.д.).',
      en: 'Conversion on the second step of the funnel (usually from the application for sale) is the percentage of the users who left the application who ultimately made the transaction (made a purchase, paid a subscription, etc.).'
    }
  },
  {
    name: 'AvP',
    html: {
      ru: 'Средний чек - сумма денег, которую пользователь в среднем платит за товары или услуги за один раз.',
      en: 'The sum of money our customer paid for our goods or services.'
    }
  },
  {
    name: 'COGS',
    html: {
      ru: 'Средние затраты, которые несет предприятие на обеспечение продажи (себестоимость товара, затраты на упаковку и доставку, и т.д.).',
      en: 'Average costs that the enterprise incurs to secure sales (cost of goods, packaging and shipping costs, etc.).'
    }
  },
  {
    name: 'Ret',
    html: {
      ru: 'Возвратность (Retention), в некоторых источниках APC (Averege Payment Count) - среднее количество повторных продаж за период времени. По умолчанию расчитывается за все время жизни клиента.',
      en: 'Average number of payments made by one customer during a set period of time. APC by default is counted for the whole life period. This value should be calculated carefully. It should never be rounded up.'
    }
  },
  {
    name: 'ARPPU',
    html: {
      ru: 'Доход с одного платящего пользователя - показатель прибыльности проекта в расчете на одного платящего пользователя. Этот показатель часто путают с ARPU, где в расчет берется весь объем пользователей. При расчете ARPPU используется число только платящих пользователей.',
      en: 'Average Revenue Per Pay User or Average revenue per customer shows how much we get from sales to one customer during a set period of time. It doesn’t include the marketing cost. ARPC is determined by the formula ARPC = (AvP — COGS) × APC — 1sCOGS. ARPC is an important value for business effectiveness estimation. By comparing it to CAC we can measure the return on marketing investments.'
    }
  },
  {
    name: 'ARPU',
    html: {
      ru: 'Доход с одного пользователя - доход, получаемый с пользователя в единицу времени (обычно по умолчанию это месяц) (один из ключевых показателей для IT-компаний и онлайн-сервисов, показывающий доход на одного привлеченного пользователя).',
      en: '(sometimes known as average revenue per unit), usually abbreviated to ARPU, is a measure used primarily by consumer communications, digital media, and networking companies, defined as the total revenue divided by the number of subscribers.'
    }
  },
  {
    name: 'CPA',
    html: {
      ru: 'Стоимость лида (стоимость зарегистрированного пользователя) - стоимость привлечения на сайт (сервис) одного пользователя, совершившего целевое действие (оставившего контактные данные, позвонившего, оформившего заказ).',
      en: 'Cost per acquisition of one User. It is determined by dividing the entire marketing budget by the number of all Users. Unlike CAC, CPA is an actionable metric. It doesn’t depend on other metrics, such as conversion or User flow.'
    }
  },
  {
    name: 'CPPU',
    html: {
      ru: 'Стоимость привлечения покупателя (стоимость продажи).',
      en: 'CPPU or CAC or CPS — Customer acquisition cost shows how much we spent on getting the customer. For example, we can divide the marketing budget by the number of customers we attracted.'
    }
  },
  {
    name: 'LTV',
    html: {
      ru: 'Life Time Value - операционная маржа за все время.',
      en: ''
    }
  },
  {
    name: 'ROI',
    html: {
      ru: 'Окупаемость инвестиций ROI (от англ. return on investment) или ROR (англ. rate of return) — финансовый коэффициент, иллюстрирующий уровень доходности или убыточности бизнеса, учитывая сумму сделанных в этот бизнес инвестиций. инвестиций.',
      en: ''
    }
  },
  {
    name: 'Margin',
    html: {
      ru: 'Маржа с одной продажи',
      en: ''
    }
  },
  {
    name: 'Leads',
    html: {
      ru: 'Количество лидов (количество полученных заявок или количество зарегестрированных пользователей)',
      en: ''
    }
  },
  {
    name: 'CPL',
    html: {
      ru: 'Стоимость лида (стоимость зарегистрированного пользователя)',
      en: ''
    }
  },
  {
    name: 'Buyers',
    html: {
      ru: 'Количество успешно совершенных сделок (за которые компания получила деньги).',
      en: ''
    }
  },
  {
    name: 'Budget',
    html: {
      ru: 'Общий бюджет рекламной кампании.',
      en: ''
    }
  },
  {
    name: 'OperatingProfit',
    html: {
      ru: 'Операционная прибыль на покупателя за все время',
      en: ''
    }
  },
  {
    name: 'OperatingMargin',
    html: {
      ru: 'Операционная маржа за все время',
      en: ''
    }
  },
  {
    name: 'firstSaleRev',
    html: {
      ru: 'Операционная прибыль на первой продаже',
      en: ''
    }
  },
  {
    name: 'Revenue',
    html: {
      ru: 'Доход с канала (операционная прибыль)',
      en: ''
    }
  },
  {
    name: '_Revenue',
    html: {
      ru: 'Выручка без вычета COGS, именно это считают Revenue за рубежом',
      en: ''
    }
  },
  {
    name: '_Revenue',
    html: {
      ru: 'Доход с канала (операционная прибыль)',
      en: ''
    }
  },
  {
    name: 'ACorBudget',
    html: {
      ru: 'Рекламный бюджет',
      en: ''
    }
  },
  {
    name: 'GrossProfit',
    html: {
      ru: 'Валовая прибыль',
      en: ''
    }
  },
  {
    name: 'MaxCPC',
    html: {
      ru: 'Пороговый CPC',
      en: 'Maximum CPC'
    }
  },
  {
    name: 'MaxCPA',
    html: {
      ru: 'Пороговый CPA',
      en: 'Maximum CPA'
    }
  },
  {
    name: 'Profit Per Paying User',
    html: {
      ru: 'Доход (Profit) на покупателя с учетом стоимости привлечения',
      en: ''
    }
  },
  {
    name: 'Profit',
    html: {
      ru: '',
      en: ''
    }
  }
]


// WEBPACK FOOTER //
// ./src/services/descrParams.js